import { FC, useRef } from "react";
import classnames from "classnames";

import styles from "../FormField.module.scss";

interface ITextAreaFormFieldProps {
  name?: string;
  inputProps: any;
  registerField?: any;
  autoheight?: boolean;
  checksPresenceName?: (
    e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLElement>,
    name: string,
  ) => void;
}

const TextAreaFormField: FC<ITextAreaFormFieldProps> = ({
  name,
  inputProps,
  registerField,
  checksPresenceName,
  autoheight = false,
}) => {
  const ref = useRef(null);

  function onInput(e) {
    if (checksPresenceName) {
      checksPresenceName(e, name);
    }
    let {
      paddingBottom,
      paddingTop,
      lineHeight,
    }: {
      paddingBottom: string | number;
      paddingTop: string | number;
      lineHeight: string | number;
    } = window.getComputedStyle(e.target);

    lineHeight = Number(lineHeight.match(/^\d+/)[0]);
    paddingBottom = Number(paddingBottom.match(/^\d+/)[0]);
    paddingTop = Number(paddingTop.match(/^\d+/)[0]);

    const calculatedHeight =
      Math.floor(
        (e.target.scrollHeight - (paddingBottom + paddingTop)) / lineHeight,
      ) *
        lineHeight +
      paddingBottom +
      paddingTop;

    e.target.style.height = calculatedHeight + "px";
  }

  return (
    <textarea
      ref={ref}
      {...registerField}
      {...inputProps}
      className={classnames(inputProps.className, styles.textarea, {
        [styles.autoheight]: autoheight,
      })}
      onKeyUp={autoheight ? onInput : undefined}
    ></textarea>
  );
};

export default TextAreaFormField;
